import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {withStyles} from '@material-ui/core/styles';
import {
	logout,
	clickShowTerms,
	clickCloseTerms,
	clickShowManuals,
	clickCloseManuals,
	clickShowPolicy,
	clickClosePolicy
} from '../../actions';
import classNames from 'classnames';

import Progress from '../../common/containers/progress'
import Viewer from '../components/viewer/pdf-viewer'
import {releaseMode, releaseVersion} from '../const'

const styles = theme => ({
	versionText: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		width: '100%',
		color: 'rgba(255,255,255,0.2) !important',
		textAlign: 'right',
		marginBottom: '0px !important',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	innerMenu: {
		position: 'relative',
		paddingBottom: '40px !important',
		minHeight: 'calc(100vh - 60px)',
		boxSizing: 'border-box'
	}
});

class sp_nav extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			IsOpen: false,
		}
	}


	handleClickOpen = () => {
		this.setState({
			IsOpen: !this.state.IsOpen
		})
	};

	handleClickAddUser = () => {
		const doFunc = () => {
			this.props.history.push('/master/add-user');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickUserList = () => {
		const doFunc = () => {
			this.props.history.push('/master/users');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickAsnCorporate = () => {
		const doFunc = () => {
			this.props.history.push('/master/asn-corporate-management')
		}
		this.setState({
			isOpen: false
		})
		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	}

	handleClickNayoseList = () => {
		const doFunc = () => {
			this.props.history.push('/master/nayose');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}

	};

	handleClickSecomList = () => {
		const doFunc = () => {
			this.props.history.push('/master/secom-signature');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickTrHenkanList = () => {
		const doFunc = () => {
			this.props.history.push('/master/tr-henkan');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickHasonhoukokuKbnList = () => {
		const doFunc = () => {
			this.props.history.push('/master/hasonhoukoku-kbn');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickReceiptsReferencesList = () => {
		const doFunc = () => {
			this.props.history.push('/master/receipts-references');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickKeiyakuKigyou = () => {
		const doFunc = () => {
			this.props.history.push('/master/keiyaku-kigyou');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickJigyousha = () => {
		const doFunc = () => {
			this.props.history.push('/master/jigyousha');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickEmptySlips = () => {
		const doFunc = () => {
			this.props.history.push('/empty-pdf');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickDeleteSlips = () => {
		const doFunc = () => {
			this.props.history.push('/delete-list');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickMenu = () => {
		const doFunc = () => {
			this.props.history.push('/');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickInformation = () => {

		const doFunc = () => {
			this.props.history.push('/information');
		};
		this.setState({
			IsOpen: false
		});

		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	handleClickFaq = () => {

		const doFunc = () => {
			this.props.history.push('/faq');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}


	};

	handleClickLogOut = () => {

		const doFunc = () => {
			dispatch(logout());
			history.push('/');
		};

		const {dispatch, history} = this.props;
		this.setState({
			IsOpen: false
		});

		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}

	};

	handleClickOpenManuals = () => {
		this.setState({
			IsOpen: false
		});
		this.props.dispatch(clickShowManuals());
	};

	handleClickCloseManuals = () => {
		this.props.dispatch(clickCloseManuals());
	};

	handleClickOpenPolicy = () => {
		this.setState({
			IsOpen: false
		});
		this.props.dispatch(clickShowPolicy());
	};

	handleClickClosePolicy = () => {
		this.props.dispatch(clickClosePolicy());
	};

	handleClickOpenTerms = () => {
		this.setState({
			IsOpen: false
		});
		this.props.dispatch(clickShowTerms());
	};

	handleClickCloseTerms = () => {
		this.props.dispatch(clickCloseTerms());
	};

	handleClickAsnHenkan = () => {
		const doFunc = () => {
			this.props.history.push('/master/asncode-henkan');
		};
		this.setState({
			IsOpen: false
		});


		if (this.props.redirectFunc) {
			this.props.redirectFunc(doFunc);
		} else {
			doFunc();
		}
	};

	isSet = (val) => {
		if (val === "" || val === null || val === undefined) {
			return false;
		} else {
			return true;
		}
	};

	render() {
		const {auth, documents, classes} = this.props;
		const {manualOpen, manualUrl, termsOpen, termsUrl, policyOpen, policyUrl} = documents;
		const {
			IsSystemAdmin,
			IsJigyoushaAdmin,
			JigyoushaIsNohinJigyousha,
			JigyoushaIsMaker,
			JigyoushaIs3PL,
			isKeiyakuKigyouMasterEditable,
			isJigyoushaMasterEditable,
			isAsnCorporateMasterEditable,
			isAsnHenkanMasterEditable,
			isHasonhoukokuKbnEditable,
			isReceiptsReferencesMasterEditable
		} = auth.user;
		const isShowSlipsMenu = JigyoushaIsMaker || JigyoushaIsNohinJigyousha || JigyoushaIs3PL;


		return ([
			<div className={classNames("sp_nav", {'is-opened': this.state.IsOpen})} key="nav">
				<div className="sp_nav_btn" onClick={this.handleClickOpen}>
					<div className="sp_nav_btn_bar sp_nav_btn_bar_top"/>
					<div className="sp_nav_btn_bar sp_nav_btn_bar_middle"/>
					<div className="sp_nav_btn_bar sp_nav_btn_bar_bottom"/>
				</div>
			</div>,
			<div className={classNames("responsive_menu_wrap", {'show': this.state.IsOpen})} key="wrap"/>,
			<div className={classNames("responsive_menu", {'show': this.state.IsOpen})} key="menu">
				<div className={classNames("inner_menu", classes.innerMenu)}>
					<div id="sub_menus">
						<p className="menu_title">管理メニュー</p>
						{
							(
								(releaseMode() <= 3 && (IsSystemAdmin || IsJigyoushaAdmin))
								||
								(releaseMode() === 4 && IsSystemAdmin)
							)
							&&
							<ul className="clearfix">
								{isKeiyakuKigyouMasterEditable &&
								<li onClick={this.handleClickKeiyakuKigyou}><i className="fa fa-angle-right"
																			   aria-hidden="true"/>企業管理
								</li>
								}
								{isJigyoushaMasterEditable &&
								<li onClick={this.handleClickJigyousha}><i className="fa fa-angle-right"
																		   aria-hidden="true"/>事業者管理
								</li>
								}
								<li onClick={this.handleClickUserList}><i className="fa fa-angle-right"
																		  aria-hidden="true"/>ユーザー管理
								</li>
								{releaseMode() <= 3 &&
								<li onClick={this.handleClickNayoseList}><i className="fa fa-angle-right"
																			aria-hidden="true"/>名寄せ管理
								</li>
								}
								{releaseMode() <= 3 && isReceiptsReferencesMasterEditable &&
								<li onClick={this.handleClickReceiptsReferencesList}><i className="fa fa-angle-right"
																						aria-hidden="true"/>電子受領照会管理
								</li>
								}
								{IsSystemAdmin &&
								<li onClick={this.handleClickSecomList}><i className="fa fa-angle-right"
																		   aria-hidden="true"/>SECOM署名管理
								</li>
								}
								{isAsnCorporateMasterEditable &&
								<li onClick={this.handleClickAsnCorporate}><i className="fa fa-angle-right"
																			  aria-hidden="true"/>ASN連携企業管理
								</li>
								}
								{isAsnHenkanMasterEditable &&
								<li onClick={this.handleClickAsnHenkan}><i className="fa fa-angle-right"
																		   aria-hidden="true"/>ASNコード変換
								</li>
								}
								<li onClick={this.handleClickTrHenkanList}><i className="fa fa-angle-right"
																			  aria-hidden="true"/>TR情報変換
								</li>
								{isHasonhoukokuKbnEditable &&
								<li onClick={this.handleClickHasonhoukokuKbnList}><i className="fa fa-angle-right"
																					 aria-hidden="true"/>破損報告区分管理
								</li>
								}
							</ul>
						}
					</div>
					{isShowSlipsMenu &&
					<p onClick={this.handleClickDeleteSlips}><i className="fa fa-trash-o" aria-hidden="true"/>伝票削除</p>
					}
					{isShowSlipsMenu &&
					<p className={"with_border"} onClick={this.handleClickEmptySlips}><i className="fa fa-file-pdf-o"
																						 aria-hidden="true"/>空伝票出力</p>
					}
					<p onClick={this.handleClickInformation}><i className="fa fa-info-circle" aria-hidden="true"/>お知らせ
					</p>
					<p className={"with_border"} onClick={this.handleClickFaq}><i className="fa fa-question-circle-o"
																				  aria-hidden="true"/>FAQ</p>
					{this.isSet(auth.manualFilePath) &&
					<p onClick={this.handleClickOpenManuals}><i className="fa fa-file-o" aria-hidden="true"/>ユーザーマニュアル
					</p>
					}
					{this.isSet(auth.policyFilePath) &&
					<p onClick={this.handleClickOpenPolicy}><i className="fa fa-file-o" aria-hidden="true"/>プライバシーポリシー
					</p>
					}
					{this.isSet(auth.termsFilePath) &&
					<p className={"with_border"} onClick={this.handleClickOpenTerms}><i className="fa fa-file-o"
																						aria-hidden="true"/>利用規約</p>
					}
					<p onClick={this.handleClickMenu}><i className="fa fa-bars" aria-hidden="true"/>メインメニュー</p>
					<p onClick={this.handleClickLogOut}><i className="fa fa-sign-out" aria-hidden="true"/>ログアウト</p>
					<p className={classes.versionText}>ver. {releaseVersion()}</p>
				</div>
			</div>,
			(manualOpen && <Viewer
				filePath={manualUrl}
				afterCloseFunc={this.handleClickCloseManuals}
				key={"manuals"}
			/>),
			(termsOpen && <Viewer
				filePath={termsUrl}
				afterCloseFunc={this.handleClickCloseTerms}
				key={"terms"}
			/>),
			(policyOpen && <Viewer
				filePath={policyUrl}
				afterCloseFunc={this.handleClickClosePolicy}
				key={"policy"}
			/>),

		]);
	}
}

sp_nav.propTypes = {
	history: PropTypes.object,
	redirectFunc: PropTypes.func
};

function mapStateToProps(state) {
	return {
		auth: state.auth,
		documents: state.documentsSettings
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(sp_nav);



// WEBPACK FOOTER //
// ./src/common/containers/sp_nav.js